module.exports = __webpack_public_path__ + "media/images/logo-23b0d0a6aab1faffd03968f676bab2bd.png";